module.exports = __webpack_public_path__ + "img/2496.db765880.png";